<template>
    <div class="col-12 d-flex justify-content-between align-items-center">
        <span class="justify-content-start align-items-center">
            <b class="h2">Serviços e Intervenções</b>
            <h3>{{ tipo }}</h3>
        </span>
        <div v-if="!loading">
            <b-button
                v-if="page == 'paf'"
                variant="success"
                squared
                @click="$root.redirectAcompanhamento(familia)"
            >
                <i class="mdi mdi-chevron-left mdi-18px"></i>Voltar para os
                Acompanhamentos
            </b-button>
            <b-button
                v-if="page == 'medidas'"
                variant="success"
                squared
                @click="$root.redirectMedidas(familia)"
            >
                <i class="mdi mdi-chevron-left mdi-18px"></i>Voltar para as
                Medidas
            </b-button>
            <b-button
                v-if="page == 'violencia'"
                variant="success"
                squared
                @click="$root.redirectViolacaoDireito(familia)"
            >
                <i class="mdi mdi-chevron-left mdi-18px"></i>Voltar para as
                Situações de Violação de Direitos
            </b-button>
            <b-button
                v-else
                variant="success"
                squared
                @click="$root.redirectProntuario(familia)"
            >
                <i class="mdi mdi-chevron-left mdi-18px"></i>
                <i class="mdi mdi-database-cog-outline mdi-18px"></i> Voltar
                para o Prontuário
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "HeaderServico",
    props: ["tipo", "loading", "page", "familia"],
    data() {
        return {};
    },
};
</script>
